import axios from './axios';
import config from '../../helpers/config';

export default (designId, containerId, newName) => (
  axios.post(
    `${config.designBuilderLoadDesignPath}/${designId}/containers/${containerId}/rename`,
    { Name: newName },
  )
);
